import { Text } from '@shared/components';

import {
  ContentSelectorByContentType,
  type ContentSelectorByContentTypeProps,
} from '../content-selector-by-content-type';
import { ContentTypeSection } from '../content-type-section';
import { ScorePerQuestionFormField } from '../score-per-question-form-field';

type QConfigSingleQuestionConditionsFormFieldsProps = Omit<
  Extract<ContentSelectorByContentTypeProps, { questionType: 'single' }>,
  'questionType'
> & {
  locationSelected: boolean;
  isEditModal?: boolean;
};

export default function QConfigSingleQuestionConditionsFormFields(
  props: Readonly<QConfigSingleQuestionConditionsFormFieldsProps>,
) {
  const {
    onEdit,
    levelItemsWithLevel,
    locationSelected: isLocationSelected,
    contentType,
    location,
    group,
    isEditModal,
  } = props;

  return (
    <>
      <Text variant='body1Semibold'>1. เลือกประเภทเนื้อหาที่ต้องการเพิ่ม</Text>
      <ContentTypeSection contentType={contentType} isEditModal={isEditModal} />
      <ContentSelectorByContentType
        group={group}
        onEdit={onEdit}
        location={location}
        contentType={contentType}
        questionType='single'
        levelItemsWithLevel={levelItemsWithLevel}
      />
      {isLocationSelected ? (
        <>
          <Text variant='body1Semibold'>2. ระบุคุณสมบัติข้อสอบ</Text>
          <ScorePerQuestionFormField />
        </>
      ) : null}
    </>
  );
}
